export default __webpack_public_path__ + "static/media/headset9.7fe42ba0.jfif";